import { render, staticRenderFns } from "./_Avatar.vue?vue&type=template&id=ede58b54&scoped=true&"
import script from "./_Avatar.vue?vue&type=script&lang=js&"
export * from "./_Avatar.vue?vue&type=script&lang=js&"
import style0 from "./_Avatar.vue?vue&type=style&index=0&id=ede58b54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede58b54",
  null
  
)

export default component.exports